export interface ApiResponse<TData> {
  originalResponse: any;
  status: ApiResponseStatus;
  message: string;
  code: number;
  data: TData;
}

export interface ApiError<TData> extends ApiResponse<TData> {
  originalError: any;
}

export enum ApiResponseStatus {
  SUCCESS = 'success',
  ERROR = 'error'
}
